import Constants from "../../utils/constants.js";

/**
 * Paramètres de GET /api/bilans/actes/{clientId}/xlsx (REP-03) depuis le formulaire synthèse.
 * Global : dates seules. Par patrimoine (01/10) : + patrimoine, + conteneur si « par PAV ».
 * Même classeur, seules les interventions changent (périmètre).
 */
export function bilanXlsxQuery(values) {
    const params = new URLSearchParams({dateDebut: values.dateDebut, dateFin: values.dateFin});
    if (values.bilanType === Constants.BILAN_TYPE_BY_PATRIMOINE && values.patrimoine) {
        params.set('patrimoine', String(values.patrimoine));
        if (values.byPAV && values.conteneur) {
            params.set('conteneur', String(values.conteneur));
        }
    }
    return params.toString();
}
